import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule, MatChipsModule,
  MatDatepickerModule, MatDividerModule, MatExpansionModule,
  MatFormFieldModule, MatIconModule,
  MatInputModule,
  MatMenuModule, MatNativeDateModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule
} from '@angular/material';
import { CurrencyConverterPipe } from '../utils/pipes/currency-converter.pipe';
import { VpColumnFilterPipe } from '../utils/pipes/vp-column-filter.pipe';
import { FilterHeaderService } from '../utils/services/filter-header.service';
import { PriceLevelPipe } from '../utils/pipes/price-level.pipe';
import { FxRateTypePipe } from '../payer-view/pipes/fx-rate-type.pipe';
import { DoubleDecimalPipe } from '../payer-view/pipes/doube-decimal.pipe';
import { D3Service } from '../utils/services/d3.service';

@NgModule({
  declarations: [
    PriceLevelPipe,
    FxRateTypePipe,
    DoubleDecimalPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatCardModule,
    MatTableModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatButtonModule,
    MatInputModule,
    MatExpansionModule,
    MatChipsModule,
    MatIconModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatCardModule,
    MatTableModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatButtonModule,
    MatInputModule,
    MatExpansionModule,
    MatNativeDateModule,
    MatDividerModule,
    MatChipsModule,
    MatIconModule,

    PriceLevelPipe,
    FxRateTypePipe,
    DoubleDecimalPipe
  ],
  providers: [
    DecimalPipe,
    DatePipe,
    CurrencyConverterPipe,
    FilterHeaderService,
    VpColumnFilterPipe,
    PriceLevelPipe,
    D3Service,
    FxRateTypePipe,
    DoubleDecimalPipe
  ]
})
export class GlobalCommonModule {
}
